import React from "react";

// @mui
import { styled } from '@mui/material/styles';

// component
import functionlist from '../../../image/img_funclist.png'

export default function FreePlan( { data } ) {

  // css -------------------------------------------------------------


  const Div = styled('div')(({ theme }) => ({
    display: 'flex',
    justifyContent: 'center',
    padding : 80,
    backgroundColor: theme.palette.background.default,
  }));

  const LI = styled('li')(() => ({
    fontWeight: 500,
    display: 'flex',
    alignItems: 'center',
    marginTop:'10px'
  }));

  // -------------------------------------------------------------

  return (
    <>
        
          <div style={{display :'flex'}}><p style={{ color : "rgb(26 158 248)" }}>접속 계정&nbsp;&nbsp;</p><p>{data}</p></div>
          <p style={{fontSize :'x-large', fontWeight : '700', marginTop: 30, marginBottom:10}}>프리 플랜(Free Plan)</p>
          <p>무료 플랜으로 마음껏 사용할 수 있어요.</p>
          <div style={{marginTop: 30}}>
            <span style={{fontWeight : '900', fontSize :'large'}}>주요기능</span>
            <div style={{marginTop: 10}}>
                <div>
                    <ul>
                        <LI><img src={functionlist} alt='functionlist' /><p style={{ paddingLeft: '5px' }}>접수 월 200건 무료 제공</p></LI>
                                    <LI><img src={functionlist} alt='functionlist' /><p style={{ paddingLeft: '5px' }}>청구서 월 200건 무료 발행</p></LI>
                                    <LI><img src={functionlist} alt='functionlist' /><p style={{ paddingLeft: '5px' }}>거래처 등록 무제한</p></LI>
                                    <LI><img src={functionlist} alt='functionlist' /><p style={{ paddingLeft: '5px' }}>구성원 2명까지 추가 등록</p></LI>
                        
                    </ul>
                    
                </div>
            </div>
          </div>
        
    </>
  );
}
